import "./passcode-input.css";
import { PasscodeInput } from './passcode-input';
export default PasscodeInput;